import React from 'react';

import { useContentRequirementsContext } from '../../../../features/RestrictNavigation/ContentRequirementsProvider';
import { useQuestionWidgetAssetProvider } from '../../../components/Widgets/_shared/Questions/hooks/useQuestionWidgetAssetProvider';
import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { QuestionComponent, QuestionComponentOption } from '../_shared/Question/QuestionComponent';
import { ExistingStudentWidgetProps } from '../Widget';
import { MultipleResponseQuestionWidget as MultipleResponseQuestionWidgetModel } from '@ael/core-api';

export const MultipleResponseQuestionWidget: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const questionWidget = widget as MultipleResponseQuestionWidgetModel;
  const value = questionWidget.value;

  const { getAssetDataForOption, getAssetDataForQuestionTitle: getAssetDataForQuestionTitle } =
    useQuestionWidgetAssetProvider(widget._id, value.data.options, value.data.titleAssetId);
  const options = value.data.options.map((x, index) => {
    const assetData = getAssetDataForOption(index);
    const option: QuestionComponentOption = {
      text: x.text,
      assetData: assetData,
      isCorrect: x.isCorrect,
      id: index,
    };
    return option;
  });

  const { submitWidget } = useContentRequirementsContext();
  const submit = (_: Set<number>, wasCorrect: boolean) => {
    const fulfillWithIncorrect = !value.properties.repeatUntilCorrect;

    submitWidget(questionWidget, wasCorrect, fulfillWithIncorrect);
  };

  return (
    <StudentWidgetWrapper>
      <QuestionComponent
        questionText={value.data.questionText}
        options={options}
        onAnswered={submit}
        preSelectedOptionIds={new Set<number>()}
        hasMultipleAnswers={true}
        isShuffleEnabled={value.properties.isShuffleEnabled}
        getAssetDataForQuestionTitle={getAssetDataForQuestionTitle}
        customFeedback={{
          feedbackCorrect: value.data.feedbackCorrect,
          feedbackIncorrect: value.data.feedbackIncorrect,
        }}
        revealAnswers={value.properties.revealAnswers}
        repeatUntilCorrect={value.properties.repeatUntilCorrect}
      />
    </StudentWidgetWrapper>
  );
};
